import { render, staticRenderFns } from "./newStock.vue?vue&type=template&id=3e489520&scoped=true"
import script from "./newStock.vue?vue&type=script&lang=js"
export * from "./newStock.vue?vue&type=script&lang=js"
import style0 from "./newStock.vue?vue&type=style&index=0&id=3e489520&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e489520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e489520')) {
      api.createRecord('3e489520', component.options)
    } else {
      api.reload('3e489520', component.options)
    }
    module.hot.accept("./newStock.vue?vue&type=template&id=3e489520&scoped=true", function () {
      api.rerender('3e489520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/newStock.vue"
export default component.exports